import '@angular/compiler';
import { PageFinecomComponent } from './page.finecom/page.finecom.component';
import { PageRnfComponent } from './page.rnf/page.rnf.component';
import { PageNightComponent } from './page.night/page.night.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageSamboComponent } from './page.sambo/page.sambo.component';
import { PageFormboxComponent } from './page.formbox/page.formbox.component';
import { PageFinestyleComponent } from './page.finestyle/page.finestyle.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageHomeComponent } from './page.home/page.home.component';
import { PageNetmartComponent } from './page.netmart/page.netmart.component';
import { PageVoiceComponent } from './page.voice/page.voice.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PageCleanbagComponent } from './page.cleanbag/page.cleanbag.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';

const INDEX_PAGE = "dashboard";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "finecom",
                component: PageFinecomComponent,
                "app_id": "page.finecom"
            },
            {
                "path": "rnf",
                component: PageRnfComponent,
                "app_id": "page.rnf"
            },
            {
                "path": "night",
                component: PageNightComponent,
                "app_id": "page.night"
            },
            {
                "path": "sambo",
                component: PageSamboComponent,
                "app_id": "page.sambo"
            },
            {
                "path": "formbox",
                component: PageFormboxComponent,
                "app_id": "page.formbox"
            },
            {
                "path": "finestyle",
                component: PageFinestyleComponent,
                "app_id": "page.finestyle"
            },
            {
                "path": "",
                component: PageHomeComponent,
                "app_id": "page.home"
            },
            {
                "path": "netmart",
                component: PageNetmartComponent,
                "app_id": "page.netmart"
            },
            {
                "path": "voice",
                component: PageVoiceComponent,
                "app_id": "page.voice"
            },
            {
                "path": "cleanbag",
                component: PageCleanbagComponent,
                "app_id": "page.cleanbag"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }